import Vue from 'vue'
import Router from 'vue-router'

import clubs from '@/router/Dashboard/clubs'
import club from '@/router/Dashboard/club'
import changelog from '@/router/Dashboard/changelog'
import tutorial from '@/router/Dashboard/tutorial'
import privacy from '@/router/Dashboard/privacy'
import cookies from '@/router/Dashboard/cookies'
import terms from '@/router/Dashboard/terms'
import tests from '@/router/Dashboard/tests'
import home from '@/router/Dashboard/home'
import widgetMatch from '@/router/Widget/match'

const BaseLayout = () => import('@/components/Base/Layout/BaseLayout.vue')
const NotFound = () => import('@/components/GeneralViews/NotFoundPage.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: BaseLayout,
      redirect: {
        name: 'Sports',
      },
      children: [
        clubs,
        club,
        changelog,
        tutorial,
        privacy,
        terms,
        cookies,
        tests,
        widgetMatch,
        home,
      ],
    },
    { path: '*', component: NotFound },
  ],
})
